exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.shake[data-v-0abfed56] {\n  animation: shake-data-v-0abfed56 0.82s;\n  transform: translate3d(0, 0, 0);\n}\n@keyframes shake-data-v-0abfed56 {\n10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n}\n20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n}\n30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n}\n40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n}\n}\n.checkboxError[data-v-0abfed56] {\n  color: red;\n}\n", ""]);

// exports
